module.exports = "/_next/static/images/ffabb7a702e2d5be7752d03e6393b01a-card-xs@2x.jpg";